<template>
    <div class="login-btn-container">
      <div :style="{ width: '100%' }">
        <v-btn
          @click="onClick"
          :loading="loading"
          :flat="isFlat"
          class="btn"
          :class="[btnClass]"
          :type="btnType"
          tabindex="3"
        >
          <v-slide-x-transition v-if="!isOtpFieldOpen">
            <div>
              <v-icon class="login-icon" :icon="icon" color="white" />
              {{ buttonText }}
            </div>
          </v-slide-x-transition>
          <v-slide-x-reverse-transition v-else>
            <div class="enter">
              <v-icon :icon="'mdi-arrow-left-circle'" color="white" />
              {{ enterText }}
            </div>
          </v-slide-x-reverse-transition>
        </v-btn>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      isOtpFieldOpen: {
        type: Boolean,
        default: false,
      },
      buttonText: {
        type: String,
        default: "Login",
      },
      enterText: {
        type: String,
        default: "Enter",
      },
      mode: {
        type: String,
        default: "login",
      },
      btnHeight: {
        type: String,
        default: "62px",
      },
      textSize: {
        type: String,
        default: "20px",
      },
      icon: {
        type: String,
        default: "mdi-cellphone-arrow-down-variant",
      },
      isFlat: {
        type: Boolean,
        default: false,
      },
      btnBoxShadow: {
        type: String,
        default: "",
      },
      btnType: {
        type: String,
        default: "submit",
      },
      btnRadius: {
        type: String,
        default: "15px",
      },
    },
    methods: {
      onClick() {
        this.$emit("click");
      },
    },
    computed: {
      btnClass() {
        return "btn-" + this.mode;
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .login-btn-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: auto;
    margin-top: 0;
    .btn {
      box-shadow: v-bind(btnBoxShadow);
      height: v-bind(btnHeight);
      width: 100%;
      font-size: v-bind(textSize);
      border-radius: v-bind(btnRadius);
      color: white;
      font-weight: 100;
      line-height: 21px;
      letter-spacing: 0;
    }
    .btn-login {
      background: $cartMainColor;
    }
    .btn-downloadApp {
      background: $gradientBackground;
    }
    .enter {
      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
    }
  }
  </style>
  